import { render, staticRenderFns } from "./CarrierCompanyAdmin.vue?vue&type=template&id=3c2a9532&scoped=true&"
import script from "./CarrierCompanyAdmin.vue?vue&type=script&lang=js&"
export * from "./CarrierCompanyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CarrierCompanyAdmin.vue?vue&type=style&index=0&id=3c2a9532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a9532",
  null
  
)

export default component.exports